import { Component, Prop, h } from '@stencil/core';

/**
 * @description Heading Content (h1 - h6, or p)
 *
 * @use
 * @ssh
 * @since 4.0.0
 * @version figma-v1
 * @masked
 * @slot - `default slot`: The text of the heading.
 */
@Component({
  tag: 'hp6-heading',
  styleUrl: 'heading.scss',
  shadow: true,
})
export class Heading {
  /**
   * The size of heading to display. Sizes are defined in hp-themes
   */
  @Prop({ reflect: true }) sizeSelection: 'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs' | 'xxs' = 'md';

  /**
   * The tag used in this heading
   */
  @Prop({ reflect: true }) tagSelection: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' = 'h2';

  /**
    * This property is deprecated and will be removed in a future version. It is non-functional.
   * @deprecated Use "id" on hp6-heading instead, if needed.
   */
  @Prop() elementId?: string = null;

  render() {
    const { tagSelection } = this;

    const Tag = tagSelection;

    return (
      <Tag class="hp-heading">
        <slot />
      </Tag>
    );
  }
}
